<footer>
    <mat-divider></mat-divider>
    <div class="footer-container">
        <div class="right-container">
            <mat-icon color="primary">copyright</mat-icon>
            <span>{{currentYear}} {{ 'Powered by' | translate }}
                <a href="https://www.tapgo.ch" class="foreground" target="#">
                    <strong>{{ 'Tapgo' | translate }}</strong>
                </a>
            </span>

        </div>
    </div>

</footer>